module.exports = __webpack_public_path__ + "img/barkbadge-loading-250px.fff1afd5.gif";